import { render } from "./TipsAndTricksPage.vue?vue&type=template&id=089716cd"
const script = {}

import "./TipsAndTricksPage.vue?vue&type=style&index=0&id=089716cd&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__